// used at build time, so no TypeScript
import defaultConfig from "./default";

export default {
  ...defaultConfig,

  USER_URL: "https://beta-secure.ipdanalytics.com/User",
  RUNTIME_GQL_URL: "https://platform-gateway-dev.api.ipdanalytics.com/graphql",
  CACHE_URL: "https://lci-clinical-pipeline-server-dev.api.ipdanalytics.com/cache",
};
